module.exports = __webpack_public_path__ + "img/w6_05.9ffa3428.jpg";